import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iframe", "progress"]

  connect() {
    console.log("Video progress controller connected")
    this.initializePlayer()
  }

  async initializePlayer() {
    // Wait for Stream API to be available
    while (typeof Stream === 'undefined') {
      await new Promise(resolve => setTimeout(resolve, 100))
    }

    // Initialize player
    this.player = Stream(this.iframeTarget)
    
    // Track progress
    this.player.addEventListener('timeupdate', () => {
      Promise.all([
        this.player.currentTime(),
        this.player.duration()
      ]).then(([currentTime, duration]) => {
        if (duration > 0) {
          const progress = (currentTime / duration) * 100
          this.progressTarget.style.width = `${progress}%`
        }
      })
    })
  }
} 